interface IconProps { name: 'camera' | 'user' | 'archive' | 'arrow' | 'back' | 'settings' | 'module' | 'switch' | 'download' | 'trash' | 'home' | 'close' | 'check'; size?: number }

const paths: Record<IconProps['name'], React.ReactNode> = {
  camera: <><path d="M4 8h3l1.5-2h7L17 8h3v11H4z"/><circle cx="12" cy="13" r="3.5"/></>,
  user: <><circle cx="12" cy="8" r="3.5"/><path d="M5 20c.5-4 2.8-6 7-6s6.5 2 7 6"/></>,
  archive: <><path d="M4 7h16v13H4zM3 4h18v3H3zM9 11h6"/></>,
  arrow: <path d="m9 5 7 7-7 7M4 12h12"/>,
  back: <path d="m15 5-7 7 7 7"/>,
  settings: <><circle cx="12" cy="12" r="3"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3M5 5l2 2M17 17l2 2M19 5l-2 2M7 17l-2 2"/></>,
  module: <><path d="m12 3 8 4.5-8 4.5-8-4.5z"/><path d="m4 12 8 4.5 8-4.5M4 16.5l8 4.5 8-4.5"/></>,
  switch: <><path d="M5 8a8 8 0 0 1 13-2l2 2M19 16a8 8 0 0 1-13 2l-2-2"/><path d="M20 3v5h-5M4 21v-5h5"/></>,
  download: <path d="M12 3v12m-5-5 5 5 5-5M4 20h16"/>,
  trash: <><path d="M5 7h14M9 7V4h6v3M7 7l1 14h8l1-14M10 11v6M14 11v6"/></>,
  home: <path d="m3 11 9-8 9 8v10h-6v-6H9v6H3z"/>,
  close: <path d="M5 5l14 14M19 5 5 19"/>,
  check: <path d="m4 12 5 5L20 6"/>,
};

export function Icon({ name, size = 22 }: IconProps) {
  return <svg aria-hidden="true" className="icon" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="square" strokeLinejoin="miter">{paths[name]}</svg>;
}
